<template>
  <div class="main-content row">
    <Menu />
    <router-view></router-view>
  </div>
</template>

<script>
import Menu from "../../components/Menu";
export default {
  components: {
    Menu,
  },
  name: "Admin.vue",
};
</script>
